import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import GdsHouseholdModel from '~/glm/models/gds/gds-household-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import AnalyticsStore from '~/glm/models/analytics-store';
import Checkbox from '~/glm/components/guest-list/checkbox';
import NamesCell from '~/glm/components/guest-list/cells/names-cell';
import SelectionCell from '~/glm/components/guest-list-table/cells/selection-cell';
import GdsGuest from '~/glm/models/gds/gds-guest-model.js';
import ClickCell from '~/glm/components/guest-list/cells/click-cell';
import TextCell from '~/glm/components/guest-list/cells/text-cell.jsx';
import CheckboxCell from '~/glm/components/guest-list/cells/checkbox-cell.jsx';
import ContactInfoCell from '~/glm/components/guest-list/cells/contact-info-cell.jsx';
import RsvpCell from '~/glm/components/guest-list/cells/rsvp-cell';
import MealCell from '~/glm/components/guest-list/cells/meal-cell';
import RsvpDetailsCell from '~/glm/components/guest-list/cells/rsvp-details-cell';
import Invitation from '~/glm/models/gds/gds-invitation-model';
import rsvpStyles from './guest-row.scss';
import styles from './row.scss';

@inject('gdsUiState')
@observer
class GuestRow extends Component {
  static propTypes = {
    event: PropTypes.instanceOf(GdsEventModel).isRequired,
    guest: PropTypes.instanceOf(GdsGuest).isRequired,
    rsvpEnabled: PropTypes.bool,
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    household: PropTypes.instanceOf(GdsHouseholdModel).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
    editHousehold: PropTypes.func.isRequired,
    trackThankYou: PropTypes.func.isRequired,
    trackMeal: PropTypes.func.isRequired,
    invitation: PropTypes.instanceOf(Invitation),
    usesQuestions: PropTypes.bool.isRequired,
  };

  get isThanked() {
    const { event, household } = this.props;
    return household.anyGuestThankYouSent(event.id);
  }

  toggleGuestSelection = () => {
    const { guest } = this.props;
    const newStatus = !guest.selected;

    guest.setSelected(newStatus);
  };

  toggleThankYou = eventId => {
    const { household, trackThankYou } = this.props;

    return Promise.all([household.toggleInvitedGuestsThankYouSent(eventId), trackThankYou(!this.isThanked)]);
  };

  render() {
    const {
      household,
      event,
      gdsUiState,
      trackMeal,
      editHousehold,
      guest,
      invitation,
      analyticsStore,
      usesQuestions,
      rsvpEnabled,
    } = this.props;

    return (
      <tr key={`guest-row-${guest.id}`} className={styles.individualRow}>
        <SelectionCell>
          <Checkbox
            id={`household-checkbox-${guest.id}`}
            className={styles.selectionCheckbox}
            checked={guest.selected}
            onClick={this.toggleGuestSelection}
          />
        </SelectionCell>
        <td className={styles.householdMembersContainer} onClick={this.toggleGuestSelection}>
          <NamesCell key={`name-${guest.id}`} onClick={() => editHousehold(household)} guests={[guest]} />
        </td>
        {gdsUiState.isColumnVisible('Contact Info') && (
          <ClickCell onClick={() => editHousehold(household)}>
            <ContactInfoCell household={household} />
          </ClickCell>
        )}
        {gdsUiState.isColumnVisible('RSVP') && (
          <td className={rsvpStyles.rsvpContainer}>
            <RsvpCell
              key={`${invitation.id}-rsvpcell`}
              gdsUiState={gdsUiState}
              gdsInvitation={invitation}
              analyticsStore={analyticsStore}
              guest={guest}
            />
          </td>
        )}
        {gdsUiState.selectedEvent && gdsUiState.selectedEvent.hasMeals() && !usesQuestions && (
          <MealCell
            key={invitation.id}
            mealQuestion={event.mealQuestion}
            gdsUiState={gdsUiState}
            analyticsStore={analyticsStore}
            mealFilterMatch={this.mealFilterMatch}
            trackMeal={trackMeal}
            invitation={invitation}
          />
        )}

        {gdsUiState.isColumnVisible('Notes') && (
          <ClickCell onClick={() => editHousehold(household)}>
            <TextCell type="notes" value={household.coupleNote} className={rsvpStyles.notes} />
          </ClickCell>
        )}
        {gdsUiState.isColumnVisible('Gift') && (
          <ClickCell onClick={() => editHousehold(household)}>
            <TextCell type="gift" value={household.getGift(event.id)} className={rsvpStyles.gift} />
          </ClickCell>
        )}
        {gdsUiState.isColumnVisible('Thank You Sent') && (
          <CheckboxCell
            entity={household}
            checked={household.anyGuestThankYouSent(event.id)}
            id={household.id}
            className={rsvpStyles.thankYou}
            onClick={this.toggleThankYou.bind(null, event.id)}
          />
        )}
        {gdsUiState.isColumnVisible('RSVP Details') && rsvpEnabled && (
          <RsvpDetailsCell
            id={household.id}
            onClick={() => {
              editHousehold(household);
              gdsUiState.setHouseholdFormDefaultState('responses');
            }}
            invitations={household.guestInvitations(event.id)}
          />
        )}
      </tr>
    );
  }
}

export default GuestRow;
